export default {

    Auth: {
        State: 'state:user',
        TokenKey: 'state:tokenKey'
    },
    Theme: {
        Current: 'state:theme'
    }
};